

import React, { Component } from 'react';
import './Style.css';
import NotFound from '../../../images/empty.svg';
import '../../../custom.css';
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';
import selectImage from '../../../images/select-meta.svg';

export class Follow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            goals: [],
            history:[],
            model: {
                id: 0
            },
            topics: [],
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            },
            showBtnSend: false,
            modelHistory: {},
            isText: true,
            userLetter: [],
            selectedUserLetterView: 'Seleccione una carta de logros',
            calificationList: []
        }

    }

    componentDidMount() {

        this.GetUserFollow();
        this.GetLetterCalification();

    }

    componentDidUpdate() {
        if (document.querySelector('#userLogged')) {
            document.querySelector('#userLogged').innerText = document.querySelector('#hiddenName') ? document.querySelector('#hiddenName').value : '';
        }
    }

    async GetUserFollow() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/GetUserFollow`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ userLetter: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los usuarios para leer carta de logros',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetGoalByUserId(userId) {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/GetGoalByUserId?userId=${userId}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ goals: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los planes por tema',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetHistoryGoal(goalId) {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/GetHistoryGoal?goalId=${goalId}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ history: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando el detalle de la meta',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetLetterCalification() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/GetLetterCalification`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ calificationList: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando la lista de calificaciones',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async addHistory(type) {

        var model = this.state.modelHistory;
        model.GoalId = this.state.GoalId;
        model.Type = 'Text';
        this.setState({ modelHistory: model });

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },

            body: JSON.stringify(this.state.modelHistory)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/AddHistoryGoal`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            document.querySelector('#closeModalCalification').click();
            document.querySelector('#closeModalPorcentaje').click();
            

            const data = await response.json();
            this.setState({ history: data, modelHistory: {}, selectedCalification: '' });
            document.querySelector('.panel-evidence').scroll(0, document.querySelector('.panel-evidence').scrollHeight);

            this.GetGoalByUserId(this.state.currentLetterUserId);

        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'guardando la evidencia',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async MarkGoalAlready() {

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` }
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/MarkGoalAlready?goalId=${this.state.GoalId}`, request);

        this.setState({ loading: false });

        if (response.status == 200) {

            document.querySelector('#closeModalMarkAlready').click();
            

            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: '¡la meta se ha marcado como completada!',
                    Type: 'alert-success',
                    Show: true
                },
                GoalIsAlready: true
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'guardando la información',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async openImage(e) {
        this.setState({ imageSelected: e.currentTarget.src })
        document.querySelector('#btnOpenImage').click();
    }

    async unFollow(model) {

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            body: JSON.stringify(model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/UnFollow`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            this.GetUserFollow();
            this.setState({ goals: [{ topicName: 'Ya no sigues a este usuario' }]})
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'guardando al darse de baja en la carta de logro',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div className="mt-5 row">

                <button id="btnOpenImage" data-toggle="modal" data-target="#openImage" hidden></button>
                <div class="modal fade" id="openImage" tabindex="-1" role="dialog" aria-labelledby="closeLetterModal" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Cerrar carta de logros</h5>
                                <button type="button" id="closeModalCloseLetter" class="closeModal" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <img src={this.state.imageSelected} />

                            </div>
                            <div class="modal-footer"> <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>


                {
                    this.state.currentLetterPermission ?
                        <div className="row col-lg-12" >
                            <div class="alert alert-primary d-flex align-items-center" role="alert">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                </svg>
                                <div>
                                    Hola <b id="userLogged"></b>, usted solo tiene permisos para ver, no puede calificar ni ponerse en contacto con el participante.
                                </div>
                            </div>
                        </div> :
                        null
                }

                <div className="row col-lg-12 pre-line-text">
                    <div className="col-lg-5 border panel-goals">

                        <div class="btn-group w-100">
                                <button type="button" class="dropdown-toggle form-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span id="currentUser">{this.state.selectedUserLetterView}</span>
                                </button>

                            <div class="dropdown-menu">

                                {
                                    this.state.userLetter.length == 0 ?
                                        <span className="dropdown-item small text-small">No tiene cartas de logros para seguimiento</span> : null
                                }
                                
                                {
                                    this.state.userLetter.map(e =>
                                        <li className="row">
                                            <div className="col-md-9">
                                                <a class="dropdown-item" href="javascript: void(0)" onClick={() => {
                                                    this.state.selectedUserLetterView = `${e.student}`;
                                                    this.GetGoalByUserId(e.userId);
                                                    this.state.currentLetterPermission = e.permission == 'Solo lectura';
                                                    this.state.currentLetterUserId = e.userId;
                                                    this.state.modelLetterSelect = e;
                                                    this.setState({ GoalId: null, history: [], goalDescription: '' })
                                                }}>
                                                    <b className="dropdown-item small text-small">{e.student}</b>
                                                </a>
                                            </div>
                                            <div className="col-md-3">
                                                <a class="dropdown-item" href="javascript: void(0)" onClick={() => {
                                                    this.state.selectedUserLetterView = `${e.student}`;
                                                    this.GetGoalByUserId(e.userId);
                                                    this.state.currentLetterPermission = e.permission == 'Solo lectura';
                                                    this.state.currentLetterUserId = e.userId;
                                                    this.state.modelLetterSelect = e;
                                                    this.setState({ GoalId: null, history: [], goalDescription: '' })
                                                }}>
                                                {
                                                    e.permission == 'Calificador' ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                        </svg> :
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                                                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                                                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                                                        </svg>
                                                    }
                                                </a>
                                            </div>
                                            
                                            <div class="dropdown-divider"></div>
                                        </li>
                                    )
                                }
                            </div>
                        </div>

                        <div>

                            {
                                this.state.goals.length > 0 ?
                                    <li class="list-group-item border-bottom d-flex">
                                        <div className="col-md-12 text-center">
                                            <a target="_blank" href={'/comunidad/mi-perfil?optional=' + this.state.currentLetterUserId}>Ver perfil</a> 
                                        </div>
                                    </li> :
                                    null
                            }

                        </div>

                        {
                            this.state.goals.map(e =>

                                <div>


                                    <li class="list-group-item border-bottom d-flex">
                                        <div className="col-3">
                                            {e.photo ? <img src={e.photo} className="w-100 pointer img-model" onClick={(e) => { this.openImage(e) }}  /> : <img className="w-100" src={require('../../../images/avatar.png')} />}
                                        </div>
                                        <div className="col-8">
                                            <h6 className="cursor-pointer" onClick={() => {
                                                this.GetHistoryGoal(e.id);
                                                this.setState({ goalDescription: e.description, GoalId: e.id, GoalIsAlready: e.goalIsAlready})
                                            }}>{e.title}</h6>
                                            <span className="text-small small">{e.topicName}</span>


                                            <div class="progress mt-2">
                                                <div class="progress-bar" role="progressbar" style={{ "width": parseInt(e.percentage) + '%' }} aria-valuenow={parseInt(e.percentage)} aria-valuemin="0" aria-valuemax="100">{parseInt(e.percentage)}%</div>
                                            </div>
                                        </div>

                                    </li>


                                </div>

                            )
                        }

                        <div>

                            {
                                this.state.goals.length && !this.state.confirmUnFollow > 0 ?
                                    <li class="list-group-item border-bottom d-flex">
                                        <div className="col-md-12 text-center">
                                            <input type="button" className="btn btn-danger" value="Dejar de seguir" onClick={() => {
                                                this.setState({ confirmUnFollow: true });
                                            }}></input>
                                        </div>
                                    </li> :
                                    null
                            }

                            {
                                this.state.confirmUnFollow ?
                                <li class="list-group-item border-bottom d-flex">
                                        <div className="col-md-12 text-center">
                                            <input type="button" className="btn btn-danger" value="Confirmar" onClick={() => {
                                                this.unFollow(this.state.modelLetterSelect);
                                                this.setState({ confirmUnFollow: false });
                                            }}></input>

                                            <input type="button" className="btn btn-cancel" value="Cancelar" onClick={() => {
                                                this.setState({ confirmUnFollow: false });
                                            }}></input>
                                    </div>
                                    </li> :
                                null
                            }

                        </div>

                    </div>
                    <div className="col-lg-7 border panel-evidence">

                        {
                            !this.state.GoalId || this.state.GoalId == 0 ?
                                <div>
                                    <img className="" src={selectImage} />
                                    <span>En esta sección podrás ver el avance de las metas, pero antes debes seleccionar una de ellas.</span>
                                </div> : null
                        }

                        {
                            this.state.goalDescription ?
                                <div class="alert alert-success d-flex align-items-center" role="alert">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                    </svg>
                                    <div>
                                        {this.state.goalDescription}
                                    </div>
                                </div> :
                                null
                        }
                        

                        {
                            this.state.history.map(e =>


                                <div>
                                    {
                                        e.type == 'Text' ?
                                            <li class="bubble">
                                                <div className="text-small small"><b>{e.author}</b><b className="float-right">{new Date(e.createOnDate).toLocaleDateString()}</b></div>
                                                {e.innerHtml}
                                            </li> : null
                                    }
                                    {
                                        e.type == 'Image' ?
                                            <li class="image">
                                                <div className="text-small small"><b>{e.author}</b><b className="float-right">{new Date(e.createOnDate).toLocaleDateString()}</b></div>
                                                <img src={e.innerHtml}></img>
                                            </li> : null
                                    }
                                </div>

                            )
                        }

                        

                        
                    </div>
                    <div className="col-lg-12">

                        {
                            this.state.GoalId && this.state.GoalId > 0 && !this.state.currentLetterPermission ?
                                <div className="row bottom">
                                    <div className="col-lg-12">

                                        <a class="btn btn-line" data-toggle="modal" data-target="#sendCalificationModal" href="#" onClick={(e) => {
                                            this.setState({ modelHistory: { InnerHtml: '', GoalId: 0, Type: '' } })
                                        }}>
                                            Enviar mensaje de empoderamiento
                                        </a>
                                        <a class="btn btn-line" data-toggle="modal" data-target="#sendPorcentajeModal" href="#">
                                            Enviar Porcentaje de la meta
                                        </a>

                                        {
                                            this.state.GoalIsAlready ?
                                                <span className="btn btn-success">¡Meta completada!</span> :
                                                <a class="btn btn-line" data-toggle="modal" data-target="#markAsAlready" href="#">
                                                    ¡Meta completada!
                                                </a>
                                        }

                                        
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                </div>
                
               
                <div class="modal fade" id="markAsAlready" tabindex="-1" role="dialog" aria-labelledby="markAsAlready" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Marcar meta como completada</h5>
                                <button type="button" id="closeModalMarkAlready" class="closeModalMarkAlready" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <div class="col-lg-12">
                                    Estas seguro que deseas marcar esta meta como completada? una vez cambiada no podrá volver a su estado original.
                                </div>

                            </div>
                            <div class="modal-footer">
                                <input type="button" className="btn btn-primary" value="Sí, continuar" onClick={() => { this.MarkGoalAlready() }}></input>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="sendCalificationModal" tabindex="-1" role="dialog" aria-labelledby="sendCalificationModal" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Enviar mensaje</h5>
                                <button type="button" id="closeModalCalification" class="closeModalCalification" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <textarea maxLength="4000" className="form-control" value={this.state.modelHistory.InnerHtml} onChange={(e) => {
                                    var model = this.state.modelHistory;
                                    model.InnerHtml = e.currentTarget.value;
                                    this.setState({ model: model, selectedCalification: e.currentTarget.value })
                                }}></textarea>

                            </div>
                            <div class="modal-footer">
                                <input type="button" className="btn btn-primary" value="Guardar" disabled={!this.state.modelHistory.InnerHtml} onClick={() => { this.addHistory(); }}></input>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="sendPorcentajeModal" tabindex="-1" role="dialog" aria-labelledby="sendPorcentajeModal" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Enviar porcentaje de la meta</h5>
                                <button type="button" id="closeModalPorcentaje" class="closeModalPorcentaje" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <div class="alert alert-info d-flex align-items-center" role="alert">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                    </svg>
                                    <div>
                                        Querido Senior, te invitamos a que seas muy coherente con la calificación que le vas a dar a tu estudiante, esta calificación debe de ser coherente con el proceso del estudiante y debe ser una calificación honesta. Recuerda que si ya antes calificaste de esta forma la meta del estudiante, no debes darle un porcentaje menor, por el contrario motivalo y subele el porcentaje.
                                        <br></br>
                                        <br></br>
                                        NOTA: El porcentaje que pongas no afectará el total de la carta de logros, solo lo afectará si das por COMPLETADA LA META
                                         
                                    </div>
                                </div>


                                <select value={this.state.selectedCalification} className="form-control" onChange={(e) => {
                                    var model = this.state.modelHistory;
                                    model.InnerHtml = `Avance de la meta ${e.currentTarget.value}%`;
                                    model.Percentage = parseInt(e.currentTarget.value);
                                    this.setState({ model: model, selectedCalification: e.currentTarget.value })
                                }}>
                                    <option value="">Seleccione una opción</option>
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                    <option value="20">20</option>
                                    <option value="25">25</option>
                                    <option value="30">30</option>
                                    <option value="35">35</option>
                                    <option value="40">40</option>
                                    <option value="45">45</option>
                                    <option value="50">50</option>
                                    <option value="55">55</option>
                                    <option value="60">60</option>
                                    <option value="65">65</option>
                                    <option value="70">70</option>
                                    <option value="75">75</option>
                                    <option value="80">80</option>
                                    <option value="85">85</option>
                                    <option value="90">90</option>
                                    <option value="95">95</option>
                                    <option value="100">100</option>
                                </select>

                            </div>
                            <div class="modal-footer">
                                <input type="button" className="btn btn-primary" value="Guardar" disabled={!this.state.modelHistory.InnerHtml} onClick={() => { this.addHistory(); }}></input>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }} /> : null}
                {this.state.loading ? <Loading /> : null}
            </div>
        );
    }
}
